export default {

  // 新增特种设备管理
  insertPaSpecialEquipment: '/ygsjzs/paSpecialEquipment/insertPaSpecialEquipment',
  // 修改特种设备管理
  updatePaSpecialEquipment: '/ygsjzs/paSpecialEquipment/updatePaSpecialEquipment',
  // 删除特种设备管理
  deletePaSpecialEquipment: '/ygsjzs/paSpecialEquipment/deletePaSpecialEquipment',
  // 查询特种设备管理详情
  selectPaSpecialEquipmentByDeviceId: '/ygsjzs/paSpecialEquipment/selectPaSpecialEquipmentByDeviceId',

  // 分页查询特种设备管理列表
  selectPaSpecialEquipmentByPage: '/ygsjzs/paSpecialEquipment/selectPaSpecialEquipmentByPage'

}
